module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "profile-collection"
  }, [_c('div', {
    staticClass: "columns is-mobile"
  }, [_c('div', {
    staticClass: "column"
  }, [_vm._l((_vm.personList), function(person) {
    return [_c('article', {
      staticClass: "media"
    }, [_c('figure', {
      staticClass: "media-left"
    }, [_c('p', {
      staticClass: "image is-64x64 sui-avatar"
    }, [_c('img', {
      attrs: {
        "src": person.avatarUrl
      }
    })])]), _vm._v(" "), _c('div', {
      staticClass: "media-content"
    }, [_c('div', {
      staticClass: "content max-lines--one-plus-three"
    }, [_c('p', [_c('router-link', {
      attrs: {
        "to": {
          name: 'profile',
          params: {
            profileId: person.profileId
          }
        }
      }
    }, [_c('strong', [_vm._v(_vm._s(person.name))])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_vm._v("\n                  " + _vm._s(person.bio) + "\n                ")])], 1)])]), _vm._v(" "), _c('div', {
      staticClass: "media-right"
    }, [_c('br'), _vm._v(" "), (!person.isMe) ? [(person.isFollowed) ? _c('button', {
      staticClass: "button is-outlined",
      on: {
        "click": function($event) {
          _vm.unfollowPerson(person)
        }
      }
    }, [_vm._v("following")]) : _c('button', {
      staticClass: "button is-primary",
      on: {
        "click": function($event) {
          _vm.followPerson(person)
        }
      }
    }, [_vm._v("follow")])] : _vm._e()], 2)])]
  })], 2)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-3afd12fd"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ProfileFollowing.vue
// module id = 280
// module chunks = 1